<template>
    <VTooltip
        theme='info-tooltip'
        class="inline"
    >
        <div tabindex="0" class="icon-info-circle cursor-pointer inline" :class="color"><span class="sr-only">Info icon</span></div>

        <template #popper>
            <div class='flex gap-1'>
                <div class='flex-shrink-0'>
                    <span class='icon-info-circle text-sm' :class="color" aria-hidden='true'></span>
                </div>
                <div>
                    <p>{{ content }}</p>
                </div>
            </div>
        </template>
    </VTooltip>
</template>

<script>
export default {
    props: {
        content: String,
        color: {
            type: String,
            default: 'text-green-accessible'
        }
    },
};
</script>

<style lang="postcss" scoped>
</style>
